import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_BACKGROUND,
  DARK_TEXTBOX_BACKGROUND,
  DARK_TEXTBOX_BORDER,
  LIGHT_BACKGROUND,
  LIGHT_TEXTBOX_BACKGROUND,
  LIGHT_TEXTBOX_BORDER,
} = COLORS;

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3, 4),
      backgroundColor: theme.palette.type === 'dark' ? DARK_BACKGROUND : LIGHT_BACKGROUND,
      minHeight: '100vh',
      overflow: 'hidden',
      [theme.breakpoints.down('lg')]: {
        padding: theme.spacing(2, 2.5),
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
      '& .MuiInputBase-formControl': {
        height: '50px !important',
        fontSize: '14px !important',
        overflow: 'hidden',
      },
      '& .MuiFormControl-root': {
        marginTop: '10px',
        marginBottom: '10px',
      },
      '& .MuiInputBase-root': {
        background: theme.palette.type === 'dark' ? DARK_TEXTBOX_BACKGROUND : LIGHT_TEXTBOX_BACKGROUND,
      },
      '& fieldset': {
        borderColor: theme.palette.type === 'dark' ? DARK_TEXTBOX_BORDER : LIGHT_TEXTBOX_BORDER,
      },
      '&.not-chrome': {
        padding: '64px 32px 24px 32px !important',
      },
    },
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(2, 0),

      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
  }),
);
